import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetches portfolio images flagged `is_home_featured` by the admin.
 * Returns an array of { id, url, thumb_url, service_slug, caption }.
 * The Home page bento grid falls back to a static set when this is empty.
 */
export function useHomeFeatured() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${BACKEND}/api/portfolio-home-featured`);
        const data = await r.json();
        if (cancelled) return;
        // STRICT: the home page must never show watermarked photos. Photos
        // without a `clean_url` (legacy uploads from before iter 15) are
        // skipped — the bento grid falls back to the static service covers.
        const mapped = (Array.isArray(data) ? data : [])
          .filter((x) => x.clean_url)
          .map((x) => ({
            id: x.id,
            url: `${BACKEND}${x.clean_url}`,
            thumb_url: `${BACKEND}${x.clean_thumb_url || x.clean_url}`,
            service_slug: x.service_slug,
            caption: x.caption || null,
          }));
        setItems(mapped);
        setLoaded(true);
      } catch {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { items, loaded };
}
